export default __webpack_public_path__ + "src/archives/video/transitions-dc800b.mp4";